import { render, staticRenderFns } from "./payMode.vue?vue&type=template&id=516decce&"
import script from "./payMode.vue?vue&type=script&lang=js&"
export * from "./payMode.vue?vue&type=script&lang=js&"
import style0 from "./payMode.vue?vue&type=style&index=0&id=516decce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports